var map = {
	"./happy_paws.svg": 91023,
	"./incredible_cookies.svg": 21488,
	"./mothers_family_rings.svg": 83514,
	"./one_and_only_prints.svg": 59437,
	"./wunsch_kalender.svg": 7226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95197;